import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import '../styles/Lots.css'

const LotCard = ({ 
    compoundLogo,
    compoundMap,
    compoundName,
    mainImage,
    mainMapImage,
    lotsAvailable,
    link,
    description,
    price,
    size,
    disclaimer

  }) => {

    return (

      <div className="container-lots">

      <div className="lot-card">

        <div className="compound-logo">
    
        <Link to={link}> 
          <img src={compoundLogo} alt="Compound Logo"/>
        </Link>

        </div>

        <div className="compound-map">

          <Link to="/map"> 
            <img src={compoundMap} alt="Compound Map" />
          </Link>
        </div>
        
  
        <div className="map-container-lots">

          <img src={mainImage} alt="Main Lot Map" className="main-map-lots" /> 

          <img src={mainMapImage} alt="Main Lot Map" className="main-map-lots" />

          {/* <div className="mini-map-container">
            <img src={miniMapImage} alt="Miniature Map" className="mini-map-lots" />
          </div> */}

        </div>
  
        <div className="card-content">
          <div className="card-header">
            <Link to={link}> 
            <h3>{compoundName}</h3>
            </Link>
            <span className="lots-badge">{lotsAvailable} lots available</span>
          </div>
          <p className="description-lots">{description}</p>
          <h3>{price}</h3>
          <p>{size}</p>
          <p>{disclaimer}</p>
        </div>
      </div>
    </div>
    );
  };
  
  LotCard.propTypes = {
    compoundLogo: PropTypes.string.isRequired,
    compoundMap: PropTypes.string.isRequired,
    compoundName: PropTypes.string.isRequired,
    mainImage: PropTypes.string.isRequired,
    mainMapImage: PropTypes.string.isRequired,
    miniMapImage: PropTypes.string.isRequired,
    lotsAvailable: PropTypes.number.isRequired,
    link: PropTypes.string.isRequired,
    smallMap: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    disclaimer: PropTypes.string.isRequired
  };

export default LotCard;